export const joinValidStrings = (strings, delimiter = '') => strings
  .filter(string => string)
  .join(delimiter);

export const truncate = (string, length) => (
  string && string.length > length ? `${string.substring(0, length - 3)}...` : string
);

export const addTrailingSlash = (string = '') => string.replace(/\/?$/, '/');

export const removeTrailingSlash = (string = '') => string.replace(/\/$/, '');

export const removeLeadingSlash = (string = '') => string.replace(/^\//, '');

export const removeDoubleSlashes = (string = '') => string.replace(/\/\//g, '/');

export const toCamelCase = (string = '') => string.replace(/[_-]([a-z])/g, match => match[1].toUpperCase());

export const toUnderscores = (string = '') => string.replace(/([a-z][A-Z])/g, match => `${match[0]}_${match[1].toLowerCase()}`);



// WEBPACK FOOTER //
// ./src/universal/ui/utils/string.js